// src/pages/About.js
import React from 'react';
import styled from 'styled-components';
import { SocialIcon } from 'react-social-icons';

const AboutWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: #0C2340;
  text-align: center;
`;

const Content = styled.div`
  line-height: 1.6;
`;

const About = () => {
  return (
    <AboutWrapper>
      <Title>About Us</Title>
      <Content>
        <p><strong>Welcome to Shamrock Services!</strong></p>
        <p>Shamrock Services was started in June 2024 by husband-and-wife team of Bobby and Angela Leonard.</p>
        <p>Bobby, a Michigan native, grew up just outside South Bend, Indiana. He spent many fall weekends on the Notre Dame campus, passionately rooting for the Fighting Irish. In 2010, Bobby moved to Chattanooga and quickly embraced it as his new home.</p>
        <p>Angela was born in Asheville, NC, where she spent most of her summers listening to bobwhites on her great aunt's porch, enjoying family barbecues, and playing with her younger brother. In 2001, she relocated to Cleveland, TN.</p>
        <p>Chattanooga became the backdrop for Bobby and Angela's love story. It's where they met, fell in love, and decided to build their family. After 14 years immersed in the city's culture, their family has grown to include three dogs, two children, and one fish. Now, they're eager to give back to the community that has given them so much.</p>
        <p>At Shamrock Services, we're committed to running our business with transparency, honesty, and fair pricing. We believe in delivering exceptional value without overcharging our clients. Our team brings a perfect blend of creativity and expertise to every project. Angela has a keen eye for design and aesthetics, while Bobby draws from his six years of experience building tiny homes, embracing every challenge with enthusiasm. Together, we're ready to tackle any household need with skill and innovation.</p>
        <p>We're in love with the Tennessee Valley and excited about the opportunity to contribute to its beauty and functionality. Shamrock Services is here to help with any household needs. Let us bring our passion, creativity, and commitment to excellence to your next home project!</p>
      </Content>
      <SocialIcon url='https://www.instagram.com/shamrock_services_llc/' />
      <SocialIcon url='https://www.facebook.com/profile.php?id=61562666398013' />
    </AboutWrapper>
  );
};

export default About;